import { useQuery, useInfiniteQuery, UseInfiniteQueryResult } from 'react-query'
import request from '../request'
import { type Notification } from '@demandlocal/utils/lib/mongo/models/Notifications/Notifications'
import { type UserNotification as DBUserNotification } from '@demandlocal/utils/lib/mongo/models/Notifications/UserNotifications'

export type UserNotification = Notification & Pick<DBUserNotification, 'readAt'>
interface PaginationInfo {
  total: number
  page: number
  pageSize: number
}

interface NotificationResponse {
  data: UserNotification[]
  pagination: PaginationInfo
}

interface QueryParams {
  page?: number
  pageSize?: number
}

export const useGetUserNotifications = (): UseInfiniteQueryResult<
  NotificationResponse,
  Error
> => {
  return useInfiniteQuery<NotificationResponse, Error>(
    ['userNotifications'],
    async ({ pageParam = 1 }) => {
      const response = await request<NotificationResponse>({
        url: `/notifications`,
        method: 'GET',
        params: {
          page: pageParam,
          pageSize: 20,
        } as QueryParams,
      })
      return response
    },
    {
      getNextPageParam: (lastPage: NotificationResponse): number | undefined => {
        const { page, total, pageSize } = lastPage.pagination
        return page < Math.ceil(total / pageSize) ? page + 1 : undefined
      },
      getPreviousPageParam: (firstPage: NotificationResponse): number | undefined => {
        const { page } = firstPage.pagination
        return page > 1 ? page - 1 : undefined
      },
      refetchInterval: 30 * 1000,
    },
  )
}
